import { render, staticRenderFns } from "./AdElement.vue?vue&type=template&id=9380fe0c&scoped=true&"
import script from "./AdElement.vue?vue&type=script&lang=js&"
export * from "./AdElement.vue?vue&type=script&lang=js&"
import style0 from "./AdElement.vue?vue&type=style&index=0&id=9380fe0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9380fe0c",
  null
  
)

export default component.exports